import { STATUS_BOARD_ROUTE } from '../general/router/constants';
import { allPermissions } from '../general/utils/authHelper';
import Permission from '../shared/constants/Permission';
import { statusBoardLoader } from './loaders';

const StatusBoardPage = () => import('@/statusBoard/views/StatusBoardPage.vue');

export default [
  {
    path: '/status-board',
    name: STATUS_BOARD_ROUTE,
    component: StatusBoardPage,
    meta: {
      hasAccess: allPermissions(Permission.ACCESS_TO_DOSSIERS, Permission.ACCESS_TO_ALL_DOSSIERS),
      title: 'statusBoard.pageTitle',
      logicalModule: 'status-board',
    },
    props: {
      context: statusBoardLoader,
    },
  },
];
